"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const fmko_ts_widgets_1 = require("fmko-ts-widgets");
const SimpleGroupingLayout_1 = tslib_1.__importDefault(require("./SimpleGroupingLayout"));
const RenderingContext_1 = tslib_1.__importDefault(require("./renderers/RenderingContext"));
const ExpanderColumnConfig_1 = tslib_1.__importDefault(require("./expanding/ExpanderColumnConfig"));
const AbstractGroupingLayout_1 = require("./AbstractGroupingLayout");
const GridConstants_1 = tslib_1.__importDefault(require("./GridConstants"));
class SortColumnGroupingLayout extends SimpleGroupingLayout_1.default {
    constructor(dataManager, gridConfig, table, inlineSingleElementGroups) {
        super(dataManager, gridConfig, table, null, null, false, true);
        this.inlineSingleElementGroups = inlineSingleElementGroups;
    }
    getRowStyle(row) {
        if (this.groupMap.size < this.dataManager.getNumberOfRows() && row === this.groupMap.size - 1) {
            // If grouping reduces the number of rows, delegate layout is not able to figure out when to add "last" class
            return [...this.delegate.getRowStyle(row), GridConstants_1.default.GRID_ROW_LAST];
        }
        return this.delegate.getRowStyle(row);
    }
    getCellStyle(row, column) {
        const defaultStyle = this.delegate.getCellStyle(row, column);
        if (this.dataManager.getSortedByColumn() === column) {
            if (defaultStyle?.length > 0) {
                return [...defaultStyle, GridConstants_1.default.GRID_COLUMN_SORTED];
            }
        }
        return defaultStyle;
    }
    getColSpan(row, column) {
        return this.delegate.getColSpan(row, column);
    }
    renderCell(tdElement, ctx, row, column) {
        const group = this.groupForDomRow(row);
        if (this.inlineSingleElementGroups && group.rows.length === 1) {
            // Render single element groups directly, ie. ungrouped
            this.delegate.renderCell(tdElement, ctx, 0, column);
            if (column === this.dataManager.getSortedByColumn()) {
                ctx.html(" (1)");
            }
        }
        else {
            // For group headers only render sort and expander column
            if (column === this.dataManager.getSortedByColumn()) {
                const columnConfig = this.gridConfig.getColumn(column);
                const objectToDisplay = columnConfig.getData(group.rows[0].data); // Render sort column based on the first row of the group
                columnConfig.renderer.render(ctx, objectToDisplay);
                ctx.html(` (${group.rows.length})`);
            }
            else if (this.gridConfig.getColumn(column) instanceof ExpanderColumnConfig_1.default) {
                const expandButton = new fmko_ts_widgets_1.ImageWidget({
                    alt: "Udvid/Luk",
                    imageDimension: fmko_ts_widgets_1.ImageDimensions.XL,
                    src: fmko_ts_common_1.ImageSrcWithVersion.getImage(fmko_ts_common_1.ImageSrc.EXPAND)
                });
                fmko_ts_common_1.WCAG.addButtonEvent({
                    callback: () => {
                        this.expandOrCollapseGroup(group, expandButton);
                    },
                    element: expandButton.element
                });
                ctx.setWidget(expandButton);
            }
        }
    }
    dataChanged() {
        if (!this.groupMap) {
            this.groupMap = new Map();
        }
        else {
            this.groupMap.clear();
        }
        let logicalRow = 0;
        for (let data of this.dataManager.getDataRows()) {
            const sortColumnConfig = this.gridConfig.getColumn(this.dataManager.getSortedByColumn());
            const displayedObject = sortColumnConfig.getData(data);
            let group = this.groupMap.get(displayedObject);
            if (!group) {
                group = new AbstractGroupingLayout_1.GroupDesc();
                this.groupMap.set(displayedObject, group);
            }
            const rowDesc = new AbstractGroupingLayout_1.RowDesc(data, logicalRow);
            group.rows.push(rowDesc);
            logicalRow++;
        }
        this.delegate.dataChanged(false);
    }
    expandGroup(group) {
        const insertPos = this.findInsertPosition(group);
        for (let row = 0; row < group.rows.length; row++) {
            const insertedDomRow = insertPos + row;
            const insertedRow = this.table.insertRow(insertedDomRow);
            for (let cellIndex = 0; cellIndex < this.gridConfig.getNumberOfColumns(); cellIndex++) {
                const tdElement = this.table.ensureCell({
                    row: insertedDomRow,
                    cellIndex: cellIndex
                });
                if (cellIndex === this.dataManager.getSortedByColumn()) {
                    // Don't render sort column - this is rendered in the group header row
                    tdElement?.classList.add(GridConstants_1.default.GRID_COLUMN_SORTED);
                }
                else {
                    const ctx = new RenderingContext_1.default();
                    // TODO figure this out: delegate.logical2DomRow(rowDesc.logicalRow), column);
                    this.delegate.renderCell(tdElement, ctx, row, cellIndex);
                    if (ctx.getCell2Widget().length > 0) {
                        this.table.setWidget(insertedDomRow, cellIndex, ctx.getCell2Widget()[0].widget);
                    }
                    tdElement.innerHTML = fmko_ts_common_1.HTMLUtils.sanitizeHTML(ctx.toString());
                }
                tdElement?.classList.toggle(GridConstants_1.default.GRID_CELL_FIRST, cellIndex === 0);
                tdElement?.classList.toggle(GridConstants_1.default.GRID_CELL_LAST, cellIndex === this.gridConfig.getNumberOfColumns() - 1);
            }
            insertedRow?.classList.add(GridConstants_1.default.EXPANDED_GROUP);
            insertedRow?.classList.toggle(GridConstants_1.default.EXPANDED_GROUP_FIRST, row === 0);
            insertedRow?.classList.toggle(GridConstants_1.default.EXPANDED_GROUP_LAST, row === group.rows.length - 1);
        }
        const lastRow = this.table.getElement(insertPos - 1);
        if (lastRow?.classList.contains(GridConstants_1.default.GRID_ROW_LAST)) {
            // Move the "last" style from the group header to the last element of the group
            lastRow.classList.remove(GridConstants_1.default.GRID_ROW_LAST);
            const newLastRow = this.table.getElement(insertPos - 1 + group.rows.length);
            newLastRow?.classList.add(GridConstants_1.default.GRID_ROW_LAST);
        }
        group.isExpanded = true;
    }
}
exports.default = SortColumnGroupingLayout;
//# sourceMappingURL=SortColumnGroupingLayout.js.map